<nb-layout windowMode>
  <nb-layout-column>
    <ng-content></ng-content>
  </nb-layout-column>
</nb-layout>